import { SequenceDetailsQuery } from '~/data';
import { AUDIO, AudioDefinition } from '../../items';

export const AudioHelper = (sequence: SequenceDetailsQuery['sequence']) => {
  if (!sequence.narration) return null;

  return {
    id: `${sequence.id}.audio`,
    type: AUDIO,
    values: {
      mediaUrl: sequence.narration,
      subtitlesUrl: sequence.subtitlesUrl,
      autoPlay: sequence.playAudio
    },
    items: []
  } as AudioDefinition;
};
